import { Grid3X3, List } from 'lucide-react'
import { Button } from '@/presentation/components/ui/button'

type ViewMode = 'cards' | 'table'

interface ViewToggleProps {
  viewMode: ViewMode
  onViewModeChange: (mode: ViewMode) => void
}

export default function ViewToggle({
  viewMode,
  onViewModeChange,
}: ViewToggleProps) {
  return (
    <div className="flex sm:hidden w-full gap-2">
      <Button
        variant={viewMode === 'cards' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewModeChange('cards')}
        className={`flex-1 flex items-center justify-center gap-2 transition-all duration-200 ${
          viewMode === 'cards'
            ? 'bg-primary text-primary-foreground shadow-sm border-primary'
            : 'bg-background hover:bg-accent hover:text-accent-foreground border-input text-muted-foreground hover:border-accent'
        }`}
      >
        <Grid3X3 className="h-4 w-4" />
        Cards
      </Button>
      <Button
        variant={viewMode === 'table' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewModeChange('table')}
        className={`flex-1 flex items-center justify-center gap-2 transition-all duration-200 ${
          viewMode === 'table'
            ? 'bg-primary text-primary-foreground shadow-sm border-primary'
            : 'bg-background hover:bg-accent hover:text-accent-foreground border-input text-muted-foreground hover:border-accent'
        }`}
      >
        <List className="h-4 w-4" />
        Lista
      </Button>
    </div>
  )
}
